<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1>Preface</h1>
<p>During his life, the author has accumulated many debts, not concerning money but debts of gratitude. Most of the sums owed are to persons who have departed from the physical world and some have made great contributions to our cultural and social systems.</p>
<p>To avoid infringement of copyright law, permission has been obtained to quote from the commendable <em>Classics of Western Philosophy</em> edited by Steven M Cahn and published by the Hackett Publishing Company, Inc. Acknowledgement must be made for the information received from <strong>HM</strong> Treasury and the Balance of Payments figures extracted from the Blue Books of the Office for National Statistics.</p>
<p>In addition, the quotations from the unique two volumes, <em>The Open Society and Its Enemies</em> are by kind permission of the estate of Sir Karl Popper; also, acknowledgement must be made for permission to quote from <em>The Affluent Society</em> by John Kenneth Galbraith and published by Andre Deutsch Ltd. Finally, the author is indebted to the late Dr Anthony Chadwick whose lectures on the ‘Philosophy of Religion’ were pleasant stimuli.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?64bdab4e